import React, { useState, useEffect } from 'react';
import { db } from '../utils/firebase';
import { collection, getDocs } from 'firebase/firestore';

const GraduationResults = () => {
  const [votes, setVotes] = useState([]);

  useEffect(() => {
    const fetchVotes = async () => {
      const voteData = await getDocs(collection(db, 'graduationVotes'));
      const votes = voteData.docs.map(doc => doc.data());

      // Group votes by contestantId
      const groupedVotes = votes.reduce((grouped, vote) => {
        const key = vote.contestantId;
        if (!grouped[key]) {
          grouped[key] = [];
        }
        grouped[key].push(vote);
        return grouped;
      }, {});

      // Sort contestants by vote count
      const sortedVotes = Object.entries(groupedVotes).sort((a, b) => b[1].length - a[1].length);

      setVotes(sortedVotes);
    };

    fetchVotes();
  }, []);

  return (
    <div className="container">
      <h1>Graduation Results</h1>
      
      <span>Total Votes: {votes.reduce((total, [contestantId, contestantVotes]) => total + contestantVotes.length, 0)}</span>
      <hr />
      <div className='gradResultsBoxWrapper'>

      {votes.map(([contestantId, contestantVotes]) => (
        <div key={contestantId} className='gradResultsBox'>
          <p>ID: {contestantId}</p>
          <p>Company: {contestantVotes[0].contestantCompany}</p>
          <p>Votes: {contestantVotes.length}</p>

          <h3>List Of Votes</h3>

          {contestantVotes.map((vote, index) => (
            <div key={index}>
              <span>Email: {vote.email}</span> <br />
              <span>Company: {vote.contestantCompany}</span> 
              <hr />
            </div>
          ))}
        </div>
      ))}
      </div>
    </div>
  );
};

export default GraduationResults;